import React from "react";
import { cilAccountLogout, cilExternalLink, cilLink } from "@coreui/icons";
import CIcon from "@coreui/icons-react";
import {
  CDropdown,
  CDropdownDivider,
  CDropdownItem,
  CDropdownMenu,
  CDropdownToggle,
} from "@coreui/react";

interface Props {
  onLogout: () => void;
}

export const AppsLinks: React.FC<Props> = ({ onLogout }) => {
  return (
    <CDropdown className="AppsLinks" variant="nav-item">
      <CDropdownToggle caret={false}>
        <CIcon icon={cilLink} />
      </CDropdownToggle>
      <CDropdownMenu>
        <CDropdownItem
          href="https://updater.frontends.tradingdroid.net/controller/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <CIcon icon={cilExternalLink} className="me-2" />
          Controller
        </CDropdownItem>
        <CDropdownItem
          href="https://updater.frontends.tradingdroid.net/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <CIcon icon={cilExternalLink} className="me-2" />
          Updater
        </CDropdownItem>
        <CDropdownDivider />
        <CDropdownItem onClick={onLogout}>
          <CIcon icon={cilAccountLogout} className="me-2" />
          Logout
        </CDropdownItem>
      </CDropdownMenu>
    </CDropdown>
  );
};
